import axios from 'axios';
import authService from '@/auth/authService';
// import router from '../router';
import store from '../store';

import Vue from 'vue';

export const HTTPFront = axios.create({
    baseURL: '/',
});

Vue.config.errorHandler = (err, vm, info) => {
    console.log('central errorHandler', { err, vm, info });
    // TODO: Perform any custom logic or log to server
};

// Solo se renueva la sesión si hay una sesión que renovar y la petición no usa un token propio
// (skipAuthRefresh, p. ej. el assetsToken del QR público). Sin esto, un 401 en pantallas públicas
// (QR, 2FA, certificados) disparaba logout + recarga en bucle.
const shouldRefreshSession = config => !config?.skipAuthRefresh && !!localStorage.getItem('refreshToken');

const interceptor = async error => {
    const status = error?.response ? error.response.status : null;
    if (status === 401 && shouldRefreshSession(error.config)) {
        try {
            await authService.refreshToken();
            error.config.headers.Authorization = 'Bearer ' + store.getters.token;
            error.config.baseURL = undefined;
            return axios.request(error.config);
        } catch (err) {
            store.dispatch('manageExpiredRefreshToken');
        }
    }
    return Promise.reject(error);
};

// const httpClients = [HTTPFront, HTTPAuth];

[HTTPFront].forEach(httpClient => httpClient.interceptors.response.use(response => response, interceptor));
